import isUserA from "components/users/is-a"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"

export default function useTesting() {
  const currentUser = useCurrentUser()

  if (isUserA(currentUser, "tester") || window.RAILS_ENV == "test") {
    return true
  }

  return false
}
